import './index.css';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import ServicesSubMenu from '../ServicesSubMenu';
import ServicesPricingCTA from '../ServicesPricingCTA';
import sampleBadgePawsforward from '../../assets/images/samples/sample_badge_pawsforward.webp';
import sampleBusinessCardTray1 from '../../assets/images/samples/sample_business_card_tray_1.webp';
import sampleBusinessMagnetAveryjane from '../../assets/images/samples/sample_business_magnet_averyjane.webp';
import sampleBusinessMagnetDicksonstretBookshop from '../../assets/images/samples/sample_business_magnet_dicksonstret_bookshop.webp';
import sampleBusinessMagnetFarmers from '../../assets/images/samples/sample_business_magnet_farmers.webp';
import sampleBusinessMagnetHandshake from '../../assets/images/samples/sample_business_magnet_handshake.webp';
import sampleBusinessMagnetHandshake2 from '../../assets/images/samples/sample_business_magnet_handshake2.webp';
import sampleBusinessMagnetHole from '../../assets/images/samples/sample_business_magnet_hole.webp';
import sampleBusinessMagnetHoleLot from '../../assets/images/samples/sample_business_magnet_hole_lot.webp';
import sampleBusinessMagnetRazorbackRentals from '../../assets/images/samples/sample_business_magnet_razorback_rentals.webp';
import sampleBusinessMagnetSummermoon from '../../assets/images/samples/sample_business_magnet_summermoon.webp';
import sampleBusinessMagnetTidying from '../../assets/images/samples/sample_business_magnet_tidying.webp';
import sampleBusinessMagnetsAtHandskake from '../../assets/images/samples/sample_business_magnets_at_handskake.webp';
import sampleClickerCoffeecup from '../../assets/images/samples/sample_clicker_coffeecup.webp';
import sampleClickerPaw from '../../assets/images/samples/sample_clicker_paw.webp';
import sampleCreaturesStandardHog1 from '../../assets/images/samples/sample_creatures_standard_hog1.webp';
import sampleCustomParty from '../../assets/images/samples/sample_custom_party.webp';
import sampleEventSheepdogGalaBasket from '../../assets/images/samples/sample_event_sheepdog_gala_basket.webp';
import sampleKeychainFriends from '../../assets/images/samples/sample_keychain_friends.webp';
import sampleKeychainSmallRazorbackRentals from '../../assets/images/samples/sample_keychain_small_razorback_rentals.webp';
import sampleKeychainSports from '../../assets/images/samples/sample_keychain_sports.webp';
import sampleLicenseplateHole from '../../assets/images/samples/sample_licenseplate_hole.webp';
import sampleLithoColorOrt from '../../assets/images/samples/sample_litho_color_ort.webp';
import sampleLithoSilver from '../../assets/images/samples/sample_litho_silver.webp';
import sampleLithoSuncatchChristmas from '../../assets/images/samples/sample_litho_suncatch_christmas.webp';
import sampleLithoSuncatcherDog from '../../assets/images/samples/sample_litho_suncatcher_dog.webp';
import sampleMiscDogtags from '../../assets/images/samples/sample_misc_dogtags.webp';
import sampleMiscDogtags2 from '../../assets/images/samples/sample_misc_dogtags2.webp';
import sampleSportsFootballJerseyNameNumberMagnet1 from '../../assets/images/samples/sample_sports_football_jersey_name_number_magnet1.webp';
import sampleSportsRickyb from '../../assets/images/samples/sample_sports_rickyb.webp';

const sample_images = [
  {
    category: 'business_magnet',
    path: sampleBusinessMagnetAveryjane,
    index: '0',
    active: true,
    sub_text: 'Business Magnet for Avery Jane Embroidery'
  },
  {
    category: 'business_magnet',
    path: sampleBusinessMagnetDicksonstretBookshop,
    index: '1',
    active: false,
    sub_text: 'Business Magnet for Dickson Street Bookshop'
  },
  {
    category: 'business_magnet',
    path: sampleBusinessMagnetFarmers,
    index: '2',
    active: true,
    sub_text: 'Business Magnet for Farmers Insurance'
  },
  {
    category: 'business_magnet',
    path: sampleBusinessMagnetHandshake,
    index: '3',
    active: true,
    sub_text: 'Business Magnet for Handshake Cafe'
  },
  {
    category: 'business_magnet',
    path: sampleBusinessMagnetHandshake2,
    index: '4',
    active: true,
    sub_text: 'These magnets for Handshake Cafe come apart and snap back together !'
  },
  {
    category: 'business_magnet',
    path: sampleBusinessMagnetHole,
    index: '5',
    active: true,
    sub_text: 'Our first business magnet - for Hole in the Wall Drywall Repair'
  },
  {
    category: 'business_magnet',
    path: sampleBusinessMagnetHoleLot,
    index: '6',
    active: true,
    sub_text: 'A collecction of Hole in the Wall magnets'
  },
  {
    category: 'business_magnet',
    path: sampleBusinessMagnetRazorbackRentals,
    index: '7',
    active: true,
    sub_text: 'Another sample for Razorback Rentals'
  },
  {
    category: 'business_magnet',
    path: sampleBusinessMagnetSummermoon,
    index: '8',
    active: false,
    sub_text: 'Summer Moon Coffee Shop'
  },
  {
    category: 'business_magnet',
    path: sampleBusinessMagnetTidying,
    index: '9',
    active: true,
    sub_text: 'A local professional cleaning company - Tidying by Kimberly May'
  },
  {
    category: 'business_magnet',
    path: sampleBusinessMagnetsAtHandskake,
    index: '10',
    active: true,
    sub_text: 'Business Magnets at Handshake Cafe at Fayetteville Public Library'
  },
  {
    category: 'badge',
    path: sampleBadgePawsforward,
    index: '0',
    active: true,
    sub_text: 'Name Badge for Paws Forward'
  },
  {
    category: 'business_card_tray',
    path: sampleBusinessCardTray1,
    index: '0',
    active: true,
    sub_text: 'Business Card Tray for Masterminds of Business'
  },
  {
    category: 'clicker',
    path: sampleClickerCoffeecup,
    index: '0',
    active: true,
    sub_text: 'Coffee Cup Clicker'
  },
  {
    category: 'clicker',
    path: sampleClickerPaw,
    index: '1',
    active: true,
    sub_text: 'Animal Paw Clicker'
  },
  {
    category: 'creatures',
    path: sampleCreaturesStandardHog1,
    index: '0',
    active: true,
    sub_text: 'Custom Hog Character Charm'
  },
  {
    category: 'custom_party',
    path: sampleCustomParty,
    index: '0',
    active: true,
    sub_text: 'Sample Custom Party'
  },
  {
    category: 'custom_party',
    path: sampleEventSheepdogGalaBasket,
    index: '1',
    active: true,
    sub_text: 'Custom Event Favor for Sheepdog Gala Basket'
  },
  {
    category: 'keychain',
    path: sampleKeychainFriends,
    index: '0',
    active: true,
    sub_text: 'Keychain for friends'
  },
  {
    category: 'keychain',
    path: sampleKeychainSmallRazorbackRentals,
    index: '1',
    active: true,
    sub_text: 'Keychain for Razorback Rentals'
  },
  {
    category: 'keychain',
    path: sampleKeychainSports,
    index: '2',
    active: true,
    sub_text: 'Keychain Sports - Soccer, Football, Baseball, Tennis'
  },
  {
    category: 'licenseplate',
    path: sampleLicenseplateHole,
    index: '0',
    active: true,
    sub_text: 'License Plate Hole In The Wall Drywall Repair'
  },
  {
    category: 'litho',
    path: sampleLithoColorOrt,
    index: '0',
    active: true,
    sub_text: 'Colored Lithophane Lightbox for Ozark Regional Transit'
  },
  {
    category: 'litho',
    path: sampleLithoSilver,
    index: '1',
    active: true,
    sub_text: 'Lithophane Silver'
  },
  {
    category: 'litho',
    path: sampleLithoSuncatchChristmas,
    index: '2',
    active: true,
    sub_text: 'Lithophane Suncatcher Christmas Themed'
  },
  {
    category: 'litho',
    path: sampleLithoSuncatcherDog,
    index: '3',
    active: true,
    sub_text: 'Lithophane Suncatcher Dog'
  },
  {
    category: 'misc',
    path: sampleMiscDogtags,
    index: '0',
    active: true,
    sub_text: 'Dog Tags'
  },
  {
    category: 'misc',
    path: sampleMiscDogtags2,
    index: '1',
    active: true,
    sub_text: 'Dog Tags'
  },
  {
    category: 'sports',
    path: sampleSportsFootballJerseyNameNumberMagnet1,
    index: '0',
    active: true,
    sub_text: 'Football Jersey Name and Number Magnet'
  },
  {
    category: 'sports',
    path: sampleSportsRickyb,
    index: '1',
    active: true,
    sub_text: 'Sports Fan Customized Character'
  }
];


const printTypes = [
  {
    title: 'Business Magnets',
    category: 'business_magnet',
    description:
      'Better than a flyer, a custom business magnet gives your brand a constant presence within your customer\'s home.',
  },
  {
    title: 'License Plates',
    category: 'licenseplate',
    description:
      'A 3D printed license plate stands out above a flat graphic one with raised details, bold colors, and a more memorable finish.',
  },
  {
    title: 'Lithophane',
    category: 'litho',
    description:
      'From a backlit suncatcher to a lightbox, we can take your personal image and bring it to life.',
  },
  {
    title: 'Keychains',
    category: 'keychain',
    description:
      'Take your name, logo, phrase, favorite animal, even your personal sports jersey and put it on a custom keychain.  Just send us a picture and we will bring it to life !',
  },
  {
    title: 'Custom Character Creatures',
    category: 'creatures',
    description:
      'Our first product and still going strong, with more than 13 different characters and growing. These cute characters can be worn on a keychain, a backpack, or a pendant.',
  },
  {
    title: 'Sports',
    category: 'sports',
    description:
      'Sports Jerseys for your local team or player.  Customized team-inspired prints.   One of our favorites is a Razorback superfan pendant inspired by Ricky B.  Note that we abide by all NIL and licensing requirements.',
  },
  {
    title: 'Card Trays',
    category: 'business_card_tray',
    description:
      'Hosting a business meeting or game night and need to store cards cleanly? We can customize the size, color, and even add your logo.',
  },
  {
    title: 'Custom Party Favors',
    category: 'custom_party',
    description:
      'We have printed custom party favors for birthdays, retirement parties, and other celebrations. Nothing beats a custom memory you can hold onto.',
  },
  {
    title: 'Name Badges',
    category: 'badge',
    description:
      'We print name badges for events in different sizes. Send us your logo and we can make it really stand out.',
  },
  {
    title: 'Fidgets and Clickers',
    category: 'clicker',
    description:
      'Coffee cups, animals, logos, and more. We can make it click and keep you entertained on your desk or on a keychain.',
  },
];

const Services3DPrints = () => {
  const [selectedSampleImage, setSelectedSampleImage] = useState<
    (typeof sample_images)[number] | null
  >(null);

  return (
    <div className="services-3dprints-page">
      <ServicesSubMenu />
      <section className="services-3dprints-hero">
        <p className="services-3dprints-kicker">Hogcloud Services</p>
        <h1>Custom 3D Printing in Northwest Arkansas</h1>
        <p>
          Professional personalized prints, business promos, keepsakes, event
          favors, prototypes, and small-batch creative products made in
          Northwest Arkansas. Bring an idea, logo, photo, or theme.
        </p>
      </section>

      <section className="print-types" aria-labelledby="print-types-title">
        <div className="print-types-header">
          <p className="services-3dprints-kicker">What We Print</p>
          <h2 id="print-types-title">Custom 3D print options</h2>
        </div>

        <div className="print-type-grid">
          {printTypes.map((printType) => {
            const printTypeImages = sample_images
              .filter(
                (sampleImage) =>
                  sampleImage.category === printType.category && sampleImage.active
              )
              .sort((a, b) => Number(a.index) - Number(b.index));

            return (
              <article className="print-type-card" key={printType.title}>
                <div className="print-type-content">
                  <h3>{printType.title}</h3>
                  <p>{printType.description}</p>
                </div>
                {printTypeImages.length > 0 ? (
                  <div className="print-type-samples">
                    {printTypeImages.map((sampleImage) => (
                      <figure className="print-type-sample" key={sampleImage.path}>
                        <button
                          className="print-type-sample-button"
                          type="button"
                          onClick={() => setSelectedSampleImage(sampleImage)}
                        >
                          <img src={sampleImage.path} alt={sampleImage.sub_text} />
                        </button>
                        <figcaption>{sampleImage.sub_text}</figcaption>
                      </figure>
                    ))}
                  </div>
                ) : (
                  <div className="print-type-image-placeholder" aria-hidden="true">
                    <span>Image coming soon</span>
                  </div>
                )}

              </article>
            );
          })}
        </div>
      </section>

      <section className="licensed-prints" aria-labelledby="licensed-prints-title">
        <div className="print-types-header">
          <p className="services-3dprints-kicker">Licensed Prints</p>
          <h2 id="licensed-prints-title">Prints from licensed creators</h2>
        </div>

        <article className="print-type-card licensed-prints-card">
          <div className="print-type-content">
            <h3>Licensed Prints</h3>
            <p>
              We can print any of the prints found with these amazing creators
              for a fee, subject to the active license terms for each creator.
            </p>
            <div className="licensed-creator-links" aria-label="Licensed creators">
              <a
                href="https://www.patreon.com/cw/Wiggle3D"
                rel="noopener noreferrer"
                target="_blank"
              >
                Wiggle3D
              </a>
              <a
                href="https://makerworld.com/en/@JIMGA/upload"
                rel="noopener noreferrer"
                target="_blank"
              >
                JIMGA
              </a>
            </div>
            <Link className="licensed-prints-policy-link" to="/3d-print-licensing">
              Review 3D print licensing
            </Link>
          </div>
        </article>
      </section>

      {selectedSampleImage && (
        <div
          className="sample-image-modal"
          role="dialog"
          aria-modal="true"
          aria-label={selectedSampleImage.sub_text}
          onClick={() => setSelectedSampleImage(null)}
        >
          <div
            className="sample-image-modal-content"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              className="sample-image-modal-close"
              type="button"
              onClick={() => setSelectedSampleImage(null)}
              aria-label="Close image preview"
            >
              Close
            </button>
            <img
              src={selectedSampleImage.path}
              alt={selectedSampleImage.sub_text}
            />
            <p>{selectedSampleImage.sub_text}</p>
          </div>
        </div>
      )}

      <ServicesPricingCTA />
    </div>
  );
};

export default Services3DPrints;
